/**
 * Centralized ECharts module for the application.
 *
 * Usage:
 *   - `app.module.ts`      → import `ArkikEchartsModule.forRoot()`
 *   - feature modules       → import `ArkikEchartsModule` (plain)
 *
 * This wraps NgxEchartsModule with a custom echarts build that only
 * includes the chart types actually used (bar, line, pie, gauge, scatter).
 * See `echarts-custom.ts` for the full list.
 */
import { ModuleWithProviders, NgModule } from '@angular/core';

// eslint-disable-next-line no-restricted-imports -- allowed because it's an initialization-only import;
import { NgxEchartsModule } from 'ngx-echarts';

@NgModule({
  imports: [NgxEchartsModule],
  exports: [NgxEchartsModule],
})
export class ArkikEchartsModule {
  static forRoot(): ModuleWithProviders<ArkikEchartsModule> {
    return {
      ngModule: ArkikEchartsModule,
      providers: [
        ...NgxEchartsModule.forRoot({
          echarts: () => import('./echarts-custom').then((m) => m.default),
        }).providers,
      ],
    };
  }
}
